import { OptionType } from "@/src/common/types"

export const StearsBusinessDateRangeMock: OptionType[] = [
  { value: "Between", label: "Between" },
  { value: "Before", label: "Before" },
  { value: "On", label: "On" },
  { value: "After", label: "After" },
  { value: "Last 5 days", label: "Last 5 days" },
  { value: "1 month", label: "1 month" },
  { value: "6 months", label: "6 months" },
  { value: "YTD", label: "YTD" }
]
